import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ConfigService } from '@osos/shared/legacy-core';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
  animations: [
    trigger('splashFadeOut', [
      state('true', style({ visibility: 'visible', opacity: '1' })),
      state('false', style({ visibility: 'hidden', opacity: '0' })),
      transition('true => false', animate(800)),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SplashScreenComponent {
  @Input() show: boolean;

  protected get logoUrl(): string {
    return this.config.orgConfig.LOGO_URL;
  }

  constructor(private config: ConfigService) {}
}
